
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { LOGOUT_ACTION_TYPE } from '../../common/client/sagas/auth';

import PanelTitle from './PanelTitle';

const UserPanel = (props) => {

    const classNames = mergeStyleSets({
        UserPanel: {
            padding: 4
        },
        title: {
            fontSize: 14,
            fontWeight: 'bold',
            padding: '5px 0 5px 0'
        }
    });

    const user = useSelector(state => {
        return (state.auth.data  && state.auth.data.user)
            ? state.auth.data.user
            : null;
    });

    const dispatch = useDispatch();

    const logout = (token) => dispatch({
        type: LOGOUT_ACTION_TYPE.DEFAULT, token
    });

    const handleClick = () => {
        logout(user.token);
    }

    return (
        <Stack verticalFill className={classNames.UserPanel} tokens={{childrenGap: 4}}>
            <Stack.Item align="stretch">
                <PanelTitle title="PŘIHLÁŠENÝ UŽIVATEL" />
            </Stack.Item>
            <Stack.Item>
                <div>{user.fullName} ({user.username})</div>
            </Stack.Item>
            <Stack.Item align="end">
                <CommandButton iconProps={{iconName: 'OutOfOffice'}} text="Odhlásit" onClick={handleClick} />
            </Stack.Item>
        </Stack>
    );
}

export default UserPanel;
